import { useCallback, useEffect, useMemo } from 'react';
import { getCoreRowModel, getExpandedRowModel, useReactTable } from '@tanstack/react-table';
import { getAutomatedCampaignColumns } from './columns/columns';
import { useAutomatedCampaigns } from '../use-automated-campaigns';
import { useResponsiveColumns } from './use-responsive-columns';
export var useAutomatedTable = function () {
    var _a = useAutomatedCampaigns(), campaigns = _a.campaigns, isLoading = _a.isLoading, count = _a.count;
    var columns = useMemo(function () { return getAutomatedCampaignColumns(); }, []);
    var columnVisibilityState = useResponsiveColumns(columns);
    var table = useReactTable({
        data: campaigns,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        getExpandedRowModel: getExpandedRowModel(),
        state: {
            columnVisibility: columnVisibilityState.columnVisibility,
        },
        autoResetPageIndex: false,
        paginateExpandedRows: false,
        manualPagination: true,
        manualSorting: true,
        manualFiltering: true,
    });
    useEffect(function () {
        if (!columnVisibilityState.hasExpandingColumns) {
            table.resetExpanded(false);
        }
    }, [columnVisibilityState.hasExpandingColumns, table]);
    var onRowClick = useCallback(function (row) {
        if (columnVisibilityState.hasExpandingColumns) {
            row.toggleExpanded();
        }
        else {
            // TODO: Navigate to campaign details when implemented
        }
    }, [columnVisibilityState.hasExpandingColumns]);
    return {
        table: table,
        isLoading: isLoading,
        count: count,
        onRowClick: onRowClick,
    };
};
